import React, { Component } from "react";
import { message, Layout, Row, Col, Input, Icon, Button } from "antd";
import axios from "axios";
import { connect } from "react-redux";
import * as actions from "../store/actions";
import "../App.css";
import logo from "../assets/dmalogo.png";

const { Content, Footer } = Layout;

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userName: "",
      password: "",
      matricula: "",
      installButton: false,
    };
  }

  componentDidMount() {
    window.deferredPrompt = null;
    if (window.location.protocol === "https:") {
      window.addEventListener("beforeinstallprompt", (event) => {
        if (window.deferredPrompt === null) {
          this.setState({
            installButton: true,
          });
        }

        event.preventDefault();
        window.deferredPrompt = event;
      });
    }
  }

  installApp = async () => {
    window.deferredPrompt.prompt();
    window.deferredPrompt.userChoice.then((result) => {
      if (result.outcome === "accepted") {
        this.setState({
          installButton: false,
        });
      }
      window.deferredPrompt = undefined;
    });
  };

  onChangeUserName = (e) => {
    this.setState({ userName: e.target.value });
  };

  onChangePassword = (e) => {
    this.setState({ password: e.target.value });
  };

  onChangeMatricula = (e) => {
    this.setState({ matricula: e.target.value });
  };

  Login = async (e) => {
    message.loading("Acessando...");
    try {
      localStorage.clear();
      let token = await axios.post(window.url_api + "/users/auth", {
        password: this.state.password,
        matricula: this.state.matricula,
      });
      localStorage.setItem("tokenUser", token.data.token);
      localStorage.setItem("user", JSON.stringify(token.data));
      window.location = "/";
    } catch (e) {
      if (e.response.status === 404) {
        message.warning("Usuário ou senha inválidos, tente novamente.");
      } else {
        message.error("Algum erro ocorreu no servidor, entre em contato.");
      }
    }
  };

  render() {
    const { userName, password, matricula } = this.state;
    return (
      <Layout className="login">
        <Content
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Row>
            <Col
              xs={{ span: 20, offset: 2 }}
              md={{ span: 12, offset: 6 }}
              lg={{ span: 8, offset: 8 }}
            >
              <div
                style={{
                  backgroundColor: "#192a56",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <Col xs={{ span: 20, offset: 2 }}>
                  <Col
                    xs={{ span: 16, offset: 2 }}
                    md={{ span: 12, offset: 6 }}
                    lg={{ span: 8, offset: 5 }}
                  >
                    <img
                      src={logo}
                      alt="logo"
                      style={{ marginBottom: 20, marginLeft: 10 }}
                    />
                  </Col>

                  <Input
                    size="large"
                    placeholder="Matrícula"
                    prefix={
                      <Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />
                    }
                    value={matricula}
                    onChange={this.onChangeMatricula}
                    style={{
                      marginTop: 20,
                    }}
                  />

                  <Input.Password
                    size="large"
                    placeholder="Senha"
                    prefix={
                      <Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />
                    }
                    value={password}
                    onChange={this.onChangePassword}
                    style={{
                      marginTop: 20,
                      marginBottom: 20,
                    }}
                  />

                  <Button
                    block
                    type="primary"
                    onClick={this.Login}
                    className="dma-primary"
                  >
                    ENTRAR
                  </Button>
                  {this.state.installButton && (
                    <Button
                      block
                      style={{ marginTop: 20 }}
                      type="success"
                      onClick={this.installApp}
                      id="butInstall"
                      className="dma-success"
                    >
                      {" "}
                      BAIXAR APP{" "}
                    </Button>
                  )}
                </Col>
              </div>
            </Col>
          </Row>
          <Footer className="footer-login" style={{ textAlign: "center" }}>
            DMA ©{new Date().getFullYear()}
            <br />
            Versão {new Date().getFullYear()}.{(new Date().getMonth() + 1).toString().padStart(2, '0')}.{process.env.REACT_APP_VERSION}
          </Footer>
        </Content>
      </Layout>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  onLogin: () => dispatch(actions.tryAuth()),
});

export default connect(null, mapDispatchToProps)(Login);
